var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-section"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.groupData.company_name))]),_c('ArchiTree',{attrs:{"treeData":_vm.archiData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }